import {useMutation} from 'react-query';
import {AxiosError} from 'axios';
import {toast} from 'react-toastify';
import postwriteImageInStorage from '.';

const usePostWriteImageInStorage = (
  handleAfterSuccess?: (data: number) => void,
) => {
  const {isLoading, mutate, isSuccess} = useMutation({
    mutationFn: (payload: IPostwriteImageInStorage) => {
      return postwriteImageInStorage(payload);
    },
    onSuccess: response => {
      handleAfterSuccess && handleAfterSuccess(response.image_id);
    },
    onError: (error: AxiosError<IAxiosErr>) => {
      toast.error(
        error?.response?.data?.message ||
          'مشکلی پیش آمده ،لطفا در زمان دیگری مراجعه فرمایید',
      );
    },
  });

  return {writeInImageStorageIsLoading: isLoading, mutate, isSuccess};
};

export default usePostWriteImageInStorage;
